import * as log from 'loglevel';
import config from 'config';

log.setLevel("debug");
log.debug(`config.environment-`+config.environment);
if(config.environment== 'production')
    log.setLevel("info");

export const logger =log;
